function Tools(){
    return (
        <section className="py-5">
            <div className="container">
                <div className="row justify-content-center text-center mb-3 mb-md-5">
                <div className="col-lg-8 col-xxl-7">
                    <span className="text-muted">Showcase</span>
                    <h2 className="display-5 fw-bold mb-3">Our Gallery</h2>
                    <p className="lead">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Soluta harum
                    ipsum venenatis metus sem veniam eveniet aperiam suscipit.
                    </p>
                </div>
                </div>
                <div
                className="carousel slide pointer-event"
                data-bs-ride="carousel"
                id="portfolioCarousel"
                >
                <div className="carousel-inner">
                    <div className="carousel-item p-4">
                    <div className="row g-5">
                        <div className="col-md-4">
                        <div className="card border-0 rounded-0 shadow mb-4 mb-md-0">
                            <img
                            alt=""
                            className="img-fluid"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                            />
                            <div className="card-body text-center mt-3">
                            <h6>Catchy Title One</h6>
                            <div className="text-muted">Project Details</div>
                            <p className="mt-3">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit ut.
                            </p>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="card border-0 rounded-0 shadow mb-4 mb-md-0">
                            <img
                            alt=""
                            className="img-fluid"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                            />
                            <div className="card-body text-center mt-3">
                            <h6>Catchy Title Two</h6>
                            <div className="text-muted">Project Details</div>
                            <p className="mt-3">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit ut.
                            </p>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="card border-0 rounded-0 shadow mb-4 mb-md-0">
                            <img
                            alt=""
                            className="img-fluid"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                            />
                            <div className="card-body text-center mt-3">
                            <h6>Catchy Title Three</h6>
                            <div className="text-muted">Project Details</div>
                            <p className="mt-3">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit ut.
                            </p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="carousel-item p-4 active">
                    <div className="row g-5">
                        <div className="col-md-4">
                        <div className="card border-0 rounded-0 shadow mb-4 mb-md-0">
                            <img
                            alt=""
                            className="img-fluid"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                            />
                            <div className="card-body text-center mt-3">
                            <h6>Catchy Title Four</h6>
                            <div className="text-muted">Project Details</div>
                            <p className="mt-3">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit ut.
                            </p>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="card border-0 rounded-0 shadow mb-4 mb-md-0">
                            <img
                            alt=""
                            className="img-fluid"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                            />
                            <div className="card-body text-center mt-3">
                            <h6>Catchy Title Five</h6>
                            <div className="text-muted">Project Details</div>
                            <p className="mt-3">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit ut.
                            </p>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="card border-0 rounded-0 shadow mb-4 mb-md-0">
                            <img
                            alt=""
                            className="img-fluid"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                            />
                            <div className="card-body text-center mt-3">
                            <h6>Catchy Title Six</h6>
                            <div className="text-muted">Project Details</div>
                            <p className="mt-3">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit ut.
                            </p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <button
                    className="carousel-control-prev"
                    data-bs-slide="prev"
                    data-bs-target="#portfolioCarousel"
                    type="button"
                >
                    <span aria-hidden="true" className="carousel-control-prev-icon" />{" "}
                    <span className="visually-hidden">Previous</span>
                </button>{" "}
                <button
                    className="carousel-control-next"
                    data-bs-slide="next"
                    data-bs-target="#portfolioCarousel"
                    type="button"
                >
                    <span aria-hidden="true" className="carousel-control-next-icon" />{" "}
                    <span className="visually-hidden">Next</span>
                </button>
                </div>
            </div>
        </section>
    );
}

export default Tools